import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./video-highlight.module.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useDispatch } from "react-redux";
import {
  setProgressBar,
  setFinishedEdit,
} from "../../../Redux/Actions/VideoHighlightAction";
export default function ProgressBar({ filled, setFilled }) {
  const { isFinishedEdit, isProgressBar } = useSelector(
    (state) => state?.videoHighlightData
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (isFinishedEdit) {
      setFilled(100);
    }
    if (filled <= 90 && isProgressBar && !isFinishedEdit) {
      setTimeout(() => setFilled((prev) => (prev += 2)), 1000);
    }
  }, [filled, isProgressBar, isFinishedEdit]);

  return (
    <div className={styles.progressBarContainer}>
      <Dialog
        open={isProgressBar}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className={styles.progressbar}>
              <div
                style={{
                  height: "100%",
                  width: `${filled}%`,
                  backgroundColor: "#8dbf6e",
                  transition: "width 0.5s",
                  textAlign: "center",
                }}
              >
                <span className={styles.progressPercent}>{filled}%</span>
              </div>
            </div>
          </DialogContentText>
          <p className="fs-20 semi-bold text-center">{`${
            filled !== 100
              ? "Video editing is in progress, Please wait!!!"
              : "Video Editing has been completed successfully, Please click OK!"
          }`}</p>
        </DialogContent>
        <DialogActions>
          <div className="col-12 col-md-12 col-lg-12 ml-auto text-center">
            {filled === 100 && (
              <button
                type="button"
                class="donebtn canBtn"
                onClick={(event) => {
                  setProgressBar(dispatch, false);
                  setFinishedEdit(dispatch, false);
                  setFilled(0);
                }}
              >
                OK
              </button>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
